;
define("menu_tree_node.tpl", function(){});

